/**
 * These constants are the constants that will be recognized
 * if they are passed in from the url query
 */

// indicates whehter the welcome prompt is hidden or not
export const WELCOME_PROMPT_HIDDEN = 'wph'

// if present disable ACT Now prompt
export const DISABLE_ACT_PROMPT = 'actp=0'

// indicates the video start time
export const VIDEO_START_TIME = 'vidStart'

// indicates the tour init from VR app
export const FROM_VR = 'fromVR'

// indicates the host
export const PLATFORM = 'pl'
// host type
export const VIRTUAL_HOST = 'v'

/**
 * button configuration for hiding buttons
 *
 * We will do a bitwise comparison, so just add value (2^n) to hide multiple
 * hide action buttons = 1
 * hide share buttons = 2
 * hide share buttons = 4
 */
export const HIDDEN_BUTTON_CONFIGURATION = 'btcg'
export const BTC_HIDE_ACTION_BUTTONS = 1
export const BTC_HIDE_SHARE_BUTTONS = 2
export const BTC_HIDE_VR_BUTTON = 4
